<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_business-how-start.title1') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_business-how-start.text1') }}<br />
						{{ $t('rtr_business-how-start.text2') }}
					</p>
					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button
							class="button_bg_white"
							@click="$router.push({ name: 'cs' })"
						>
							{{ $t('button.info') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_middle">
				<router-link :to="{ name: 'cs' }" class="link_type_02 text fc_white"
					>{{ $t('rtr_business-how-start.text3')
					}}<span class="CIRCLE_ARROW type_01"></span>
				</router-link>
			</div>
			<div class="sub_bottom mb_0">
				<h2 class="title">
					{{ $t('rtr_business-how-start.title2') }}
				</h2>
				<p class="text mb_20">
					<span class="fw_normal">{{
						$t('rtr_business-how-start.text4')
					}}</span>
					{{ $t('rtr_business-how-start.text5') }}
				</p>
				<a href="mailto:help@janopay.com" class="link_type_02"
					>help@janopay.com<span class="CIRCLE_ARROW"></span
				></a>
			</div>
		</section>
		<section class="rectangle_area">
			<div class="rectangle1">
				<h2 class="title">
					{{ $t('rtr_business-how-start.title3') }}
				</h2>
				<p class="text mb_30">
					{{ $t('rtr_business-how-start.text7') }} <br />
					{{ $t('rtr_business-how-start.text8') }}
				</p>
				<router-link :to="{ name: 'auth-register' }" class="link_type_02"
					>{{ $t('rtr_business-how-start.text9') }}
					<span class="CIRCLE_ARROW"></span
				></router-link>
			</div>
			<div class="rectangle2">
				<h2 class="title">
					{{ $t('rtr_business-how-start.title4') }}
				</h2>
				<p class="text">
					{{ $t('rtr_business-how-start.text10') }}<br />
					{{ $t('rtr_business-how-start.text11') }}<br />
					{{ $t('rtr_business-how-start.text12') }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Start',
};
</script>
<style scoped></style>
